import React, {Fragment, useRef, useState} from 'react';
import Icon from "../Icon";
import {SpinLoader} from "../Loader";
import _ from "lodash";
import {useInfiniteQuery} from "@tanstack/react-query";
import {COMMENTS_KEY, fetchSubComments} from "../../../api/public-voissa/comments";
import Comment from "./Comment";

const SubCommentList = ({
        parentId = null,
        commentId = null,
        commentType = "",
        currentUser = {},
        hasSubComments = false,
        deleteComment = () => {},
        handleSubReport = () =>{},
        setCurrentCommentEdit = () =>{},
        isAnsweringComment = false,
        setToggleSignIn = () =>{},
        subCommentAnswer = () =>{},
        previewSubComment = 2
    }) =>{
    const filter = {
        limit: 5,
        page: 1,
        sort: "-createdAt",
    };

    const [toggleSubComment, setToggleSubComment] = useState(false);
    const refContentComments = useRef(null);

    const {isSuccess : isSuccessComments, isFetched : isFetchedComments, data : dataComments, fetchNextPage : fetchNextPageComments, hasNextPage : hasNextPageComments} = useInfiniteQuery(
        [COMMENTS_KEY, parentId, commentId],
        ({pageParam = 1}) => fetchSubComments(commentType, parentId, commentId, {...filter, page : pageParam}),
        {
            enabled : !!parentId && !!commentId && hasSubComments,
            getNextPageParam: (lastPage, pages) => lastPage && lastPage.more ? pages.length +1 : undefined
        }
    );

    async function commentsNext() {
        let arrayPagination = dataComments.pageParams || [];
        let page = arrayPagination.length +1 || 2;
        await fetchNextPageComments({pageParam : page});
    }

    function updateSort(data){
        let pages = data.map((page, index) => {
            page.data = _.orderBy(page.data, ['createdAt'], ['asc']);
            page.pageNumber = index;
            return page;
        } )
        pages = _.orderBy(pages, ['pageNumber'], ['asc']);
        return pages;
    }

    let total = _.get(dataComments,'pages[0].total') || 0;


    let data = [];
    if(_.get(dataComments,'pages')){
        data = updateSort(dataComments.pages);
    }

    /*useEffect(() => {
        if(!toggleSubComment){
            setToggleSubComment(true);
        }
    }, [isSuccessComments,toggleSubComment]);*/

    return(
        <Fragment>
            <div className="all-sub-comment"  ref={refContentComments}>
                {isFetchedComments && hasNextPageComments && toggleSubComment ? (
                    <div className="show-more-subcomment" onClick={() => commentsNext()}>
                        Voir plus de commentaires
                    </div>
                ) : null}
                {!isFetchedComments && hasNextPageComments && toggleSubComment ? (
                    <div className="more-comments loading" onClick={() => commentsNext()}>
                        <SpinLoader className={"small"}/>
                    </div>
                ) : null}
                {(previewSubComment >= 1 || toggleSubComment) && data.map((group, i) => {
                    let data = [...group.data];
                    if(!toggleSubComment && previewSubComment >= 1){
                        data = data.slice(0,previewSubComment);
                    }
                    return (
                        <Fragment key={i}>
                            {data.map(comment => (
                                <Comment key={comment._id}
                                    {...comment}
                                    comment={comment}
                                    setCurrentCommentEdit={(data) => setCurrentCommentEdit({...data, parentCommentId : commentId})}
                                    currentUser={currentUser}
                                    commentsInitialized={isSuccessComments}
                                    parentId={parentId}
                                    deleteComment={(id) => deleteComment(commentId, id)}
                                    handleReport={(message) =>handleSubReport(parentId, commentId, comment.id, message)}
                                    // handleSubmit={this.handleSubmit}
                                    commentId={commentId}
                                    commentType={commentType}
                                    hasSubComments={hasSubComments}
                                    isAnsweringComment={isAnsweringComment}
                                    setToggleSignIn={(status) => setToggleSignIn(status)}
                                    subCommentAnswer={(commentId, ownerOfSubComment) => subCommentAnswer(ownerOfSubComment)}
                                />
                            ))}
                        </Fragment>
                    )
                })}
            </div>

            {((previewSubComment === 0 && total >1 ) || (total - previewSubComment) >= 1) ?
                <span className="more-comment-from-comment" onClick={() => setToggleSubComment(!toggleSubComment)}>
                   {toggleSubComment ? <><Icon type="arrow-up"/> Cacher les réponses</> : <><Icon type="share"/>Afficher les réponses</>}
                </span>
             : null}
        </Fragment>
    )
};

export default SubCommentList;